import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { ProfessionalAudience } from './components/ProfessionalAudience';
import { StatsBar } from './components/StatsBar';
import { Problems } from './components/Problems';
import { SessionMap } from './components/SessionMap';
import { Modules } from './components/Modules';
import { ModuleIncludes } from './components/ModuleIncludes';
import { Printables } from './components/Printables';
import { Comparison } from './components/Comparison';
import { Bonuses } from './components/Bonuses';
import { PricingPack } from './components/PricingPack';
import { Guarantee } from './components/Guarantee';
import { CostOfNotBuying } from './components/CostOfNotBuying';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
type MetaPixel = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[][];
  push?: MetaPixel;
  loaded?: boolean;
  version?: string;
};
declare global {
  interface Window {
    fbq?: MetaPixel;
    _fbq?: MetaPixel;
  }
}

// Pixel « T-R-C FR » (portfolio eurek_labs.france), le même que dans la boutique Impultienda.
// Vide tant que le pixel n'est pas créé : ne jamais réutiliser celui d'une autre offre.
const META_PIXEL_ID = '';
export function App() {
  useEffect(() => {
    if (!META_PIXEL_ID) return;
    if (window.fbq) {
      window.fbq('track', 'PageView');
      return;
    }

    // Même file d'attente que le code officiel de Meta : fbevents.js reprend les appels via callMethod.
    const fbq: MetaPixel = (...args: unknown[]) => {
      if (fbq.callMethod) fbq.callMethod(...args);else fbq.queue?.push(args);
    };
    fbq.push = fbq;
    fbq.queue = [];
    fbq.loaded = true;
    fbq.version = '2.0';
    window.fbq = fbq;
    window._fbq = fbq;
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/fr_FR/fbevents.js';
    document.head.appendChild(script);
    fbq('init', META_PIXEL_ID);
    fbq('track', 'PageView');
  }, []);
  return <main className="w-full overflow-x-hidden bg-mist font-sans text-navy antialiased" data-id="element-0" data-mp="3ubrfsfo6881v">
      <Hero data-id="element-1" data-mp="d4xphfd9sbdd" />
      <ProfessionalAudience data-id="element-2" data-mp="d3mmhhrnf7nb" />
      <StatsBar data-id="element-3" data-mp="d3wbb20yj8rf" />
      <Problems data-id="element-4" data-mp="d2bhjemgvtum" />
      <SessionMap data-id="element-5" data-mp="85ujnspgu14c" />
      <Modules data-id="element-6" data-mp="85bcn71csx53" />
      <ModuleIncludes data-id="element-7" data-mp="86w58r43y60b" />
      <Printables data-id="element-8" data-mp="86cqfj9r7xqi" />
      <Comparison data-id="element-9" data-mp="3gle7udba4tcj" />
      <Bonuses data-id="element-10" data-mp="3gkv0trn63pda" />
      <PricingPack data-id="element-11" data-mp="3gkl6xsz04y2b" />
      <Guarantee data-id="element-12" data-mp="3glwcnyc0cfw2" />
      <CostOfNotBuying data-id="element-13" data-mp="3gja5w0wxy4ew" />
      <FAQ data-id="element-14" data-mp="3bmbgfvo82ln1" />
      <FinalCTA data-id="element-15" data-mp="3bmtjbb5e3y3x" />
      <Footer data-id="element-16" data-mp="3bncpjulogy24" />
    </main>;
}